 document.addEventListener('DOMContentLoaded', function () {
  firstMenuOpen();
});

let resizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(firstMenuOpen, 150);
});


function firstMenuOpen() {
  if (window.innerWidth <= 989) {
    const firstHeading = document.querySelector('.footer__content-top .footer__blocks-wrapper .footer-block--menu:first-child .footer-block__heading');
    if (firstHeading) {
      const nextElem = firstHeading.nextElementSibling;
      const parentMenu = firstHeading.closest('.footer-block--menu');

      firstHeading.classList.add('active');
      firstHeading.classList.remove('collapsed');

      if (parentMenu) parentMenu.classList.add('active');
      if (nextElem) {
        nextElem.classList.add('active');
        nextElem.style.display = 'block';
      }
    }
  } else {
    
    // Remove active and reset display for all menus and headings
    const allHeadings = document.querySelectorAll('.footer-block__heading');
    const allMenus = document.querySelectorAll('.footer-block--menu');
    const allContents = document.querySelectorAll('.footer-block__heading + *');

    allHeadings.forEach(heading => {
      heading.classList.remove('active', 'collapsed');
    });

    allMenus.forEach(menu => {
      menu.classList.remove('active');
    });

    allContents.forEach(content => {
      content.classList.remove('active');
      content.style.display = ''; // resets inline style
    });

  }
}

// Click toggle behavior
document.addEventListener('click', function (e) {
  if (e.target.matches('.footer__content-top .footer__blocks-wrapper .footer-block__heading')) {
    if (window.innerWidth <= 989) {
      const heading = e.target;
      const parentMenu = heading.closest('.footer-block--menu');
      const nextElem = heading.nextElementSibling;

      heading.classList.toggle('active');
      heading.classList.toggle('collapsed');

      if (parentMenu) parentMenu.classList.toggle('active');

      if (nextElem) {
        nextElem.classList.toggle('active');
        nextElem.style.display = nextElem.style.display === 'block' ? 'none' : 'block';
      }
    }
  }
});






